import type { RouteDefinition } from "../route-definition.ts";

export const productCommunityRoutes = {
  browse: {
    path: "/browse",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  watch: {
    path: "/watch",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  forum: {
    path: "/forum",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  wiki: {
    path: "/wiki",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  search: {
    path: "/search",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  forumPost: {
    path: "/forum/:postId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  wikiPage: {
    path: "/wiki/*page",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  forumMarkdown: {
    path: "/forum.md",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "document",
  },
  wikiMarkdown: {
    path: "/wiki.md",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
